import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-510e566f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "music-player-wrapper"
};
var _hoisted_2 = {
  class: "music-player"
};
var _hoisted_3 = {
  class: "wrapper"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "left-part"
};
var _hoisted_6 = {
  key: 0,
  class: "wrapper"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "song-info-wrapper"
};
var _hoisted_9 = {
  class: "song-info cursor-pointer"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "parting-line"
  }, "-", -1
  /* HOISTED */
  );
});

var _hoisted_11 = ["title"];
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  key: 0
};
var _hoisted_14 = {
  class: "play-pace"
};
var _hoisted_15 = {
  class: "time"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "parting-line"
  }, "/", -1
  /* HOISTED */
  );
});

var _hoisted_17 = {
  class: "time"
};
var _hoisted_18 = {
  class: "center-part"
};
var _hoisted_19 = {
  class: "right-part"
};
var _hoisted_20 = {
  class: "wrapper"
};
var _hoisted_21 = {
  class: "show-word-wrapper mr-20"
};
var _hoisted_22 = {
  class: "adjust-volume-wrapper mr-20"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "list-title"
  }, "当前播放", -1
  /* HOISTED */
  );
});

var _hoisted_24 = {
  class: "operates"
};
var _hoisted_25 = {
  class: "left"
};
var _hoisted_26 = {
  class: "right"
};
var _hoisted_27 = {
  class: "collect-all"
};

var _hoisted_28 = /*#__PURE__*/_createTextVNode(" 收藏全部 ");

var _hoisted_29 = {
  class: "song-list-wrapper"
};
var _hoisted_30 = ["onDblclick"];
var _hoisted_31 = ["title"];
var _hoisted_32 = ["title"];
var _hoisted_33 = {
  class: "duration"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_mp_icon = _resolveComponent("mp-icon");

  var _component_el_tooltip = _resolveComponent("el-tooltip");

  var _component_volume_adjuster = _resolveComponent("volume-adjuster");

  var _component_PlaybackAdjuster = _resolveComponent("PlaybackAdjuster");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 底部播放器 "), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("audio", {
    ref: "audioPlayerRef",
    class: "audio-element",
    src: _ctx.currentSongUrl,
    controls: ""
  }, null, 8
  /* PROPS */
  , _hoisted_4), _createCommentVNode(" 播放器左侧 "), _createElementVNode("div", _hoisted_5, [_ctx.playingSong ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
    class: "cover-img cursor-pointer",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.displaySongDetail(_ctx.playingSong ? _ctx.playingSong.id : undefined);
    })
  }, [_createElementVNode("img", {
    src: "".concat(_ctx.playingSong.coverImg, "?param=80y80"),
    alt: "歌曲封面图片"
  }, null, 8
  /* PROPS */
  , _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
    class: "song-name word-ellipsis",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.displaySongDetail(_ctx.playingSong ? _ctx.playingSong.id : undefined);
    })
  }, _toDisplayString(_ctx.playingSong.name), 1
  /* TEXT */
  ), _hoisted_10, _createElementVNode("div", {
    class: "artist-list-wrapper word-ellipsis",
    title: _ctx.playingSongArtistStr
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artists, function (artist, index) {
    return _openBlock(), _createElementBlock("span", {
      class: "artist word-ellipsis",
      key: artist.id,
      onClick: function onClick($event) {
        return _ctx.gotoArtistDetail(artist.id);
      }
    }, [_createTextVNode(_toDisplayString(artist.name), 1
    /* TEXT */
    ), index < _ctx.artists.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "/")) : _createCommentVNode("v-if", true)], 8
    /* PROPS */
    , _hoisted_12);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 8
  /* PROPS */
  , _hoisted_11)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.transformSecondToMinute(_ctx.currentSongPlayedDuration)), 1
  /* TEXT */
  ), _hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.transformSecondToMinute(_ctx.currentSongDuration)), 1
  /* TEXT */
  )])])])) : _createCommentVNode("v-if", true)]), _createCommentVNode(" 播放器中部 "), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: "prev-song-wrapper",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.playPrev && _ctx.playPrev.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_mp_icon, {
    icon: "icon-skip-back-mini-fill",
    color: "#d33a30",
    size: 50
  })]), _ctx.isPause ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "play-song-wrapper",
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    function () {
      return _ctx.playSong && _ctx.playSong.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_mp_icon, {
    icon: "icon-play-filling",
    color: "#d33a30",
    size: 40,
    scale: 1
  })])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "play-song-wrapper",
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.playPause && _ctx.playPause.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_mp_icon, {
    icon: "icon-iov-pause",
    color: "#d33a30",
    size: 40,
    scale: 1
  })])), _createElementVNode("div", {
    class: "next-song-wrapper",
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.playNext && _ctx.playNext.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_mp_icon, {
    icon: "icon-skipnext",
    color: "#d33a30",
    size: 50
  })])]), _createCommentVNode(" 播放器右侧 "), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
    class: "play-list-wrapper mr-20",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.changeCurrentPlayBackType(_ctx.currentPlayBackType);
    })
  }, [_createCommentVNode(" :visible-arrow=\"false\" "), _createVNode(_component_el_tooltip, {
    placement: "top",
    content: _ctx.currentPlayBackType.listStateDesc,
    "show-arrow": false,
    effect: "light"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_mp_icon, {
        icon: _ctx.currentPlayBackType.listStateIcon,
        color: "#4b4b4b",
        size: 16,
        scale: 1
      }, null, 8
      /* PROPS */
      , ["icon"])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["content"])]), _createElementVNode("div", {
    class: "play-list-wrapper mr-20",
    onClick: _cache[7] || (_cache[7] = _withModifiers(function ($event) {
      return _ctx.toggleExpandSong();
    }, ["stop"]))
  }, [_createVNode(_component_mp_icon, {
    icon: "icon-24gf-playlist",
    color: _ctx.playerState.expandSong ? '#d33a30' : '#4b4b4b',
    size: 16,
    scale: 1
  }, null, 8
  /* PROPS */
  , ["color"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_mp_icon, {
    icon: "icon-geciweidianji",
    color: "#4b4b4b",
    size: 20,
    scale: 1
  })]), _createVNode(_component_volume_adjuster, {
    volume: _ctx.currentVolume * 100,
    onChangeVolume: _ctx.onChangeVolume
  }, {
    content: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_22, [_createVNode(_component_mp_icon, {
        icon: "icon-laba",
        color: "#4b4b4b",
        size: 20,
        scale: 1
      })])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["volume", "onChangeVolume"])])])]), _createCommentVNode(" 歌曲进度条 "), _createVNode(_component_PlaybackAdjuster, {
    class: "absolute left-0 top-[-7px]",
    percentage: _ctx.currentPlayRate * 100,
    onChangePercentage: _ctx.handlePlayRateChange,
    onChangeDargingState: _ctx.handleIsDragingChange
  }, null, 8
  /* PROPS */
  , ["percentage", "onChangePercentage", "onChangeDargingState"])])]), _createCommentVNode(" 右侧播放列表 "), _ctx.playerState.expandSong ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "music-song-list",
    class: "music-song-list",
    onClick: _cache[9] || (_cache[9] = _withModifiers(function ($event) {
      return _ctx.toggleExpandSong(true);
    }, ["stop"]))
  }, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, "总" + _toDisplayString(_ctx.storeSongList.length) + "首", 1
  /* TEXT */
  ), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_mp_icon, {
    class: "icon",
    icon: "add-collect",
    size: 16,
    scale: 1
  }), _hoisted_28]), _createElementVNode("div", {
    class: "clear-all",
    onClick: _cache[8] || (_cache[8] = //@ts-ignore
    function () {
      return _ctx.clearPlayList && _ctx.clearPlayList.apply(_ctx, arguments);
    })
  }, "清空列表")])]), _createCommentVNode(" 播放列表 "), _createVNode(_component_el_scrollbar, {
    height: "calc(100% - 95px)"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSongList, function (song) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["song-list", [_ctx.playingSong && _ctx.playingSong.id === song.id && 'song-list-active']]),
          key: song.id,
          onDblclick: function onDblclick($event) {
            return _ctx.playSongById(song.id);
          }
        }, [_ctx.playingSong && _ctx.playingSong.id === song.id ? (_openBlock(), _createBlock(_component_mp_icon, {
          key: 0,
          class: "icon-in-play",
          icon: "in-play",
          size: 16,
          scale: 1,
          color: "#d33a30"
        })) : _createCommentVNode("v-if", true), _createElementVNode("div", {
          class: _normalizeClass(["song-name text-ellipsis", [_ctx.playingSong && _ctx.playingSong.id === song.id && 'active']]),
          title: song.name
        }, _toDisplayString(song.name), 11
        /* TEXT, CLASS, PROPS */
        , _hoisted_31), _createElementVNode("div", {
          class: _normalizeClass(["artist text-ellipsis", [_ctx.playingSong && _ctx.playingSong.id === song.id && 'active']]),
          title: _ctx.formatArtistListToString(song.artists)
        }, _toDisplayString(_ctx.formatArtistListToString(song.artists)), 11
        /* TEXT, CLASS, PROPS */
        , _hoisted_32), _createVNode(_component_mp_icon, {
          class: "icon-link",
          icon: "link",
          scale: 1,
          size: 14,
          color: "#a3a3a3",
          bgColor: "none"
        }), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.transformSecondToMinute(song.duration || 0)), 1
        /* TEXT */
        )], 42
        /* CLASS, PROPS, HYDRATE_EVENTS */
        , _hoisted_30);
      }), 128
      /* KEYED_FRAGMENT */
      ))])];
    }),
    _: 1
    /* STABLE */

  })])) : _createCommentVNode("v-if", true)], 64
  /* STABLE_FRAGMENT */
  );
}